import React, { useState, useEffect, useContext, useRef } from 'react';
import { Button, TextField, DialogContent, DialogActions } from '@mui/material';
import PropType from 'prop-types'
import Dialog from '../Dialog';
import * as Yup from "yup";
import { Formik, Form, Field } from "formik";
import { i18n } from '../../translate/i18n';
import { makeStyles } from 'tss-react/mui';
import ButtonWithSpinner from '../ButtonWithSpinner';
import { AuthContext } from "../../context/Auth/AuthContext";
import QueueSelectUnit from "../QueueSelectUnit";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutlined";
import IconButton from "@mui/material/IconButton";
import { head } from "lodash";
import api from "../../services/api";
import { toast } from "../../services/toast";

import { isNil, isObject, has, get } from 'lodash';

const MessageSchema = Yup.object().shape({
    shortcode: Yup.string()
        .min(3, "Too Short!")
        .max(50, "Too Long!")
        .required("Required"),
    message: Yup.string()
        .min(3, "Too Short!")
        .max(900, "Too Long!")
        .required("Required")
});

const useStyles = makeStyles()((theme) => ({
    form: {
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(2),
        paddingTop: theme.spacing(1),
    },
    dropzone: {
        border: `2px dashed ${theme.palette.divider}`,
        borderRadius: 10,
        padding: theme.spacing(2),
        textAlign: "center",
        cursor: "pointer",
        color: theme.palette.text.secondary,
        transition: "border-color .15s, background-color .15s",
        "&:hover": {
            borderColor: theme.palette.primary.main,
        },
    },
    dropzoneActive: {
        borderColor: theme.palette.primary.main,
        backgroundColor: theme.palette.action.hover,
    },
    dropHint: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: theme.spacing(0.5),
    },
    previewWrap: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(1.5),
        textAlign: "left",
    },
    previewMedia: {
        width: 64,
        height: 64,
        objectFit: "cover",
        borderRadius: 8,
        flexShrink: 0,
        background: theme.palette.action.hover,
    },
    previewInfo: {
        flex: 1,
        minWidth: 0,
        overflow: "hidden",
    },
    previewName: {
        display: "block",
        fontWeight: 600,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
}));


const ACCEPTED_TYPES = ".png,.jpg,.jpeg,.mp4";
const isImageName = (name = "") => /\.(png|jpe?g|gif|webp)$/i.test(name);
const isVideoName = (name = "") => /\.(mp4|webm|ogg|mov)$/i.test(name);

function QuickMessageDialog(props) {
    const { classes, cx } = useStyles()

    const initialMessage = {
        id: null,
        shortcode: '',
        message: ''
    };

    const { modalOpen, saveMessage, editMessage, onClose, messageSelected, refresh } = props;
    const [dialogOpen, setDialogOpen] = useState(false);
    const [message, setMessage] = useState(initialMessage);
    const [loading, setLoading] = useState(false);
    const [selectedQueueIds, setSelectedQueueIds] = useState(null);

    const [attachment, setAttachment] = useState(null);
    const [dragOver, setDragOver] = useState(false);
    const [attachmentPreview, setAttachmentPreview] = useState(null);
    const attachmentFile = useRef(null);

    const { user } = useContext(AuthContext);

    useEffect(() => {
        if (!attachment) {
            setAttachmentPreview(null);
            return undefined;
        }
        const url = URL.createObjectURL(attachment);
        setAttachmentPreview(url);
        return () => URL.revokeObjectURL(url);
    }, [attachment]);

    const savedMediaUrl = message.mediapath
        ? `${process.env.REACT_APP_BACKEND_URL}/public/${message.mediapath}`
        : null;
    const previewUrl = attachmentPreview || savedMediaUrl;
    const previewName = attachment ? attachment.name : message.medianame;
    const hasAttachment = Boolean(attachment || message.mediapath);

    const handleDrop = (e) => {
        e.preventDefault();
        setDragOver(false);
        const file = head(e.dataTransfer.files);
        if (file) setAttachment(file);
    };

    useEffect(() => {
        verifyAndSetMessage()
        setDialogOpen(modalOpen)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [modalOpen])

    useEffect(() => {
        verifyAndSetMessage()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [messageSelected])

    const messageSelectedIsValid = () => {
        return isObject(messageSelected) && has(messageSelected, 'id') && !isNil(get(messageSelected, 'id'))
    }

    const verifyAndSetMessage = () => {
        if (messageSelectedIsValid()) {
            const { id, message, shortcode, departamentid, medianame, mediapath } = messageSelected

            setSelectedQueueIds(messageSelected.departamentid);
            setMessage({ id, message, shortcode, departamentid, medianame, mediapath })
        } else {
            setMessage(initialMessage)
        }
    }








    const handleSave = async (values) => {
        const QuickMessageData = { ...values };


        if (messageSelectedIsValid()) {

           
            if (attachment != null) {
                try {
                    const formData = new FormData();
                    formData.append('file', attachment);
                    await api.post(
                        `/quick-messages/${values.id}/media-upload`,
                        formData
                    );

                } catch (error) {
                    console.log(error);
                }
            }

            editMessage({
                ...messageSelected,
                ...values,
                userId: user.id,
                departamentid: selectedQueueIds !== '' ? selectedQueueIds : null
            });

        } else {






       

            if (attachment != null) {
                try {

                    
                    QuickMessageData.userId = user.id;
                    QuickMessageData.departamentid = selectedQueueIds !== '' ? selectedQueueIds : null;

                    const { data } = await api.post("/quick-messages", QuickMessageData);
                    let id = data.id;
                    
                    const formData = new FormData();
                    formData.append('file', attachment);
                    await api.post(
                        `/quick-messages/${id}/media-upload`,
                        formData
                    );

                    refresh();
                             

                } catch (error) {
                    console.log(error);
                }

            }else{
                saveMessage({
                    ...values,
                    userId: user.id,
                    departamentid: selectedQueueIds !== 0 ? selectedQueueIds : null
                });
            }
        


        }
        handleClose()
    }

    const handleClose = () => {
        setAttachment(null);
        setLoading(false);
        onClose();
    };

    const handleAttachmentFile = (e) => {
        const file = head(e.target.files);
        if (file) {
            setAttachment(file);
        }
    };



    return (
        <Dialog
            title="Respuestas Rápidas"
            modalOpen={dialogOpen}
            onClose={handleClose}
        >
            <Formik
                initialValues={message}
                enableReinitialize={true}
                validationSchema={MessageSchema}
                onSubmit={(values, actions) => {
                    setLoading(true)
                    setTimeout(() => {
                        handleSave(values);
                        actions.setSubmitting(false);
                    }, 400);
                }}
            >
 
                {({ touched, errors, isSubmitting }) => (
                    <Form>
                        <DialogContent dividers>
                            <div className={classes.form}>
                                <Field
                                    as={TextField}
                                    name="shortcode"
                                    label={i18n.t("quickMessages.dialog.shortcode")}
                                    error={touched.shortcode && Boolean(errors.shortcode)}
                                    helperText={touched.shortcode && errors.shortcode}
                                    variant="outlined"
                                    fullWidth
                                />
                                <Field
                                    as={TextField}
                                    name="message"
                                    rows={6}
                                    label={i18n.t("quickMessages.dialog.message")}
                                    multiline
                                    error={touched.message && Boolean(errors.message)}
                                    helperText={touched.message && errors.message}
                                    variant="outlined"
                                    fullWidth
                                />

                                <QueueSelectUnit
                                    selectedQueueIds={selectedQueueIds}
                                    onChange={(values) => setSelectedQueueIds(values)}
                                    fullWidth
                                />

                                <input
                                    type="file"
                                    accept={ACCEPTED_TYPES}
                                    ref={attachmentFile}
                                    onChange={(e) => handleAttachmentFile(e)}
                                    style={{ display: "none" }}
                                />

                                <div
                                    className={cx(classes.dropzone, {
                                        [classes.dropzoneActive]: dragOver,
                                    })}
                                    onClick={() => !hasAttachment && attachmentFile.current.click()}
                                    onDragOver={(e) => { e.preventDefault(); setDragOver(true); }}
                                    onDragLeave={() => setDragOver(false)}
                                    onDrop={handleDrop}
                                >
                                    {hasAttachment ? (
                                        <div className={classes.previewWrap}>
                                            {isImageName(previewName) ? (
                                                <img
                                                    src={previewUrl}
                                                    alt={previewName}
                                                    className={classes.previewMedia}
                                                />
                                            ) : isVideoName(previewName) ? (
                                                <video
                                                    src={previewUrl}
                                                    className={classes.previewMedia}
                                                    controls
                                                />
                                            ) : (
                                                <AttachFileIcon className={classes.previewMedia} />
                                            )}
                                            <div className={classes.previewInfo}>
                                                <span className={classes.previewName}>{previewName}</span>
                                                <a href={previewUrl} target="_blank" rel="noreferrer">
                                                    Ver archivo
                                                </a>
                                            </div>
                                            <IconButton
                                                aria-label="change"
                                                onClick={(e) => { e.stopPropagation(); attachmentFile.current.click(); }}
                                                disabled={isSubmitting}
                                            >
                                                <AttachFileIcon />
                                            </IconButton>
                                            <IconButton
                                                color="secondary"
                                                aria-label="remove"
                                                onClick={(e) => { e.stopPropagation(); setAttachment(null); }}
                                                disabled={isSubmitting}
                                            >
                                                <DeleteOutlineIcon />
                                            </IconButton>
                                        </div>
                                    ) : (
                                        <div className={classes.dropHint}>
                                            <AttachFileIcon />
                                            <span>Arrastra un archivo aquí o haz clic para seleccionar</span>
                                            <small>PNG, JPG o MP4</small>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleClose} color="primary">
                                Cancelar
                            </Button>
                            <ButtonWithSpinner loading={loading} color="primary" type="submit" variant="contained" autoFocus>
                                Guardar
                            </ButtonWithSpinner>
                        </DialogActions>
                    </Form>
                )}
            </Formik>
        </Dialog>
    );
}

QuickMessageDialog.propType = {
    modalOpen: PropType.bool,
    onClose: PropType.func
}

export default QuickMessageDialog;